import React, { useEffect, useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import { Card, CardBody, CardTitle, CardText } from 'reactstrap';
import Slider from "react-slick"
import styled from "styled-components";
//damage box
import damage1 from "../../../images/damage1.png";
import damage2 from "../../../images/damage2.png";
import damage3 from "../../../images/damage3.png";
import damage4 from "../../../images/damage4.png";
import damage5 from "../../../images/damage5.png";
import damage6 from "../../../images/damage6.png";
import damage7 from "../../../images/damage7.png";
import damage8 from "../../../images/damage8.png";
import damage9 from "../../../images/damage9.png";
import damage10 from "../../../images/damage10.png";

import ArrowPrev from "../../../images/arrow/luxury_prev.png";
import ArrowNext from "../../../images/arrow/luxury_next.png";

//defect
import defect1 from "../../../images/defect1.png";
import defect2 from "../../../images/defect2.png";
import defect3 from "../../../images/defect3.png";


const PreviousArrow = (props) => {
  const { className, style, onClick } = props;
  const LeftArrow = styled.div`
    &::before {
      content: "" !important;
    }
    img {
      margin-left: 15px;
      width: 40px !important;
      height: 40px !important;
      object-fit: contain;
      box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.16);
      border-radius: 30px;
      z-index: 5000;
      position: absolute;
    }

    @media (max-width: 480px) {
      img {
        width: 30px !important;
        height: 30px !important;
        position: absolute;
        left: -5px;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <KickImage src={ArrowPrev} alt="..." />
    </LeftArrow>
  );
};

const NextArrow = (props) => {
  const { className, style, onClick } = props;
  const LeftArrow = styled.div`
    &::before {
      content: "" !important;
    }
    img {
      width: 40px !important;
      height: 40px !important;
      object-fit: contain;
      box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.16);
      border-radius: 30px;
      right: 15px;
      position: absolute;
      z-index: 1000;
    }

    @media (max-width: 480px) {
      img {
        right: 10px;
        width: 30px !important;
        height: 30px !important;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <KickImage src={ArrowNext} alt="..." />
    </LeftArrow>
  );
};

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  swipe: true,
  prevArrow: <PreviousArrow />,
  nextArrow: <NextArrow />,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

function Standard({ dataFaqs }) {

  const [detail, setDetail] = useState([])

  useEffect(() => {
    dataFaqs && setDetail(dataFaqs[3].faq)
  }, [dataFaqs])

  return (
    <div id="helps-container">
      <p className="title-card">Detail Standar Produk</p>
      <p>{JSON.stringify(detail.faq)}</p>
      {
        detail && detail.map((item, index) => (
          <div className="detail-block">
            <Card>
              <CardBody>
                <CardTitle>{item.question}</CardTitle>
                <CardText>
                  <Slider {...settings}>
                    {
                      item.images && item.images.map((item, index) => (
                        <div>
                          <KickImage style={{ width: "100%", height: window.screen.availWidth > 480 ? "450px" : "150px", objectFit: "cover" }} src={item.URL} alt={item.URL} />
                        </div>
                      ))
                    }
                  </Slider>
                </CardText>
              </CardBody>
            </Card>
          </div>
        ))
      }
    </div>
  )
}

const mapStateToProps = state => ({
  dataSection: state.dataMenu.section_name,
  dataFaqs: state.dataMenu.faqs.data
});

export default connect(mapStateToProps, null)(Standard)